import ContentLoader from "react-content-loader";

const AffiliatesCarouselSkeleton = ({ ...props }) => {
  return (
    <div>
      <ContentLoader
        speed={2}
        width={"100%"}
        height={42}
        backgroundColor="#f3f3f3"
        className="flex-none rounded-lg"
        foregroundColor="#ecebeb"
        animate
        {...props}
        id="picks-carousel-skeleton"
      >
        <rect x="9" y="0" rx="0" ry="0" width="100%" height="42" />
      </ContentLoader>
      <div className="mb-1 mt-4 flex content-start gap-2 overflow-x-auto pr-1">
        {Array.from({ length: 6 }).map((_, index) => {
          return (
            <ContentLoader
              speed={2}
              width={284}
              height={220}
              key={index}
              viewBox="0 0 284 220"
              backgroundColor="#f3f3f3"
              className="flex-none rounded-lg"
              foregroundColor="#ecebeb"
              animate
              {...props}
              id={`picks-carousel-skeleton-${index}`}
            >
              <rect x="9" y="0" rx="0" ry="0" width="284" height="220" />
            </ContentLoader>
          );
        })}
      </div>
    </div>
  );
};

export default AffiliatesCarouselSkeleton;
